"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _Question = _interopRequireDefault(require("./Question.scss"));

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var _Constants = require("../../constants/Constants");

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _ScreenHelper = _interopRequireDefault(require("../../../helpers/ScreenHelper"));

var _no_image_found = _interopRequireDefault(require("./assets/no_image_found.png"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var MAX_FONT_SIZE = 16;
var MIN_FONT_SIZE = 6;

var QuestionBox = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(QuestionBox, _React$Component);

  var _super = _createSuper(QuestionBox);

  function QuestionBox(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, QuestionBox);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOrientationChange", function () {
      console.log('on orientation change', _this.props.question);
      clearTimeout(_this.calculationDelay);
      _this.calculationDelay = setTimeout(function () {
        _this.setState({
          temporaryFontSize: MAX_FONT_SIZE
        }, function () {
          //        this.calculateFontSize()
          _this.checkImgSize();

          _this.checkImgSize(true);
        });
      }, 100);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setIntervalHandleQuestionBox", function () {
      // @ts-ignore
      _this.interval = setInterval(_this.props.onTouchQuestions, 5);
    });
    _this.state = {
      temporaryFontSize: MAX_FONT_SIZE,
      imgScaled: false,
      marginTop: 0,
      questionImg: null
    };
    _this.calculationDelay = null;
    return _this;
  }

  (0, _createClass2["default"])(QuestionBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.addImgErrorListeners();
      var box = document.getElementById("question_box_text_".concat(this.props.question.number));

      if (box) {
        var imgArr = box.getElementsByTagName('img');

        if (imgArr && imgArr.length > 0) {
          var img = imgArr[0];

          if (img && img.offsetHeight === 0) {
            img.addEventListener('load', function () {
              _this2.checkImgSize();
            }); // if image cannot be loaded, just assume there is no image

            img.addEventListener('error', function () {
              _this2.calculateFontSize();
            });
          } else if (img) {
            this.checkImgSize();
            this.setState({
              questionImg: img
            });
          } else {
            this.calculateFontSize();
          }
        } else {
          this.calculateFontSize();
        }
      } // TODO: remove listener for screen orientation change?


      if (window.screen.orientation) {
        window.screen.orientation.addEventListener('change', this.onOrientationChange, false);
      }

      console.log('question box mounted');

      _ScreenHelper["default"].instance().addOnWindowSizeChangedListener(this.onOrientationChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // TODO: remove listener for screen orientation change?
      if (window.screen.orientation) {
        window.screen.orientation.removeEventListener('change', this.onOrientationChange);
      }

      _ScreenHelper["default"].instance().removeOnWindowSizeChangedListener(this.onOrientationChange);

      console.log('question box unmounted');
      clearTimeout(this.calculationDelay);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapShot) {
      var _this3 = this;

      if (this.props.editorMode && this.props.question.question !== prevProps.question.question) {
        var box = document.getElementById("question_box_text_".concat(this.props.question.number));

        if (box) {
          var img = box.getElementsByTagName('img')[0];

          if (img && img.offsetHeight === 0) {
            img.addEventListener('load', function () {
              _this3.checkImgSize();
            });
          } else if (img) {
            this.checkImgSize();
            this.setState({
              questionImg: img
            });
          } else {
            this.calculateFontSize();
          }
        }
      } else if (this.props.question.question !== prevProps.question.question) {
        this.onOrientationChange();
      }
    }
  }, {
    key: "addImgErrorListeners",
    value: function addImgErrorListeners() {
      var images = document.getElementsByTagName('img');

      if (images && images.length > 0) {
        for (var i = 0; i < images.length; i++) {
          images[i].onerror = function (e) {
            e.target.src = _no_image_found["default"];
          };
        }
      }
    }
  }, {
    key: "getScreenRatio",
    value: function getScreenRatio() {
      //    const height = window.screen.height - NAVBAR_HEIGHT
      //    const width = window.screen.width
      var height = window.innerHeight - _Constants.NAVBAR_HEIGHT;
      var width = window.innerWidth;
      return height / width;
    }
  }, {
    key: "checkImgSize",
    value: function checkImgSize() {
      var _this4 = this;

      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      //    const ratio = this.getScreenRatio()
      var box = document.getElementById('question_box_' + this.props.question.number);
      var boxText = document.getElementById('question_box_text_' + this.props.question.number);

      if (box) {
        var questionBoxWidth = box.offsetWidth;
        var questionBoxHeight = box.offsetHeight;
        var maxImgHeight = Math.min(questionBoxWidth * 9 / 16, questionBoxHeight * 0.7);
        console.log('maximaleBildgröße:', questionBoxWidth * 9 / 16, questionBoxHeight * 0.7, maxImgHeight);

        if (boxText) {
          var imgArr = boxText.getElementsByTagName('img');

          if (imgArr && imgArr.length > 0) {
            var img = imgArr[0];

            if (img) {
              if (!_DeviceInfoHelper["default"].isInternetExplorer()) {
                img.style.setProperty('max-height', maxImgHeight + 'px', 'important');
              }

              console.log('checkImgSize question box', this.props.question.number, img);

              if (img.offsetHeight > 0) {
                if (reset || img.offsetHeight > maxImgHeight) {
                  this.setState({
                    imgScaled: true
                  });

                  if (!_DeviceInfoHelper["default"].isInternetExplorer()) {
                    // calculations not working properly there
                    // this way the image is slightly shrinked with wrong ratio
                    if (!_DeviceInfoHelper["default"].isBrowser()) {
                      maxImgHeight -= 15;
                    }
                  }

                  img.style.setProperty('height', maxImgHeight + 'px', 'important'); // img.style.width = 'auto'
                  // img.style.maxWidth = '96%'
                  // img.style.paddingBottom = '2%'
                  // img.style.left = (questionBoxWidth - img.offsetWidth) / 2 + 'px'

                  img.onclick = function () {
                    return _this4.props.showImageOverlay(img);
                  };
                }
              }
            }

            setTimeout(function () {
              _this4.calculateFontSize(maxImgHeight, Boolean(img));
            }, 0);
          }
        }
      }
    }
  }, {
    key: "checkFontSize",
    value: function checkFontSize(maxImgHeight, hasImg) {
      try {
        var box = document.getElementById('question_box_' + this.props.question.number);
        var boxText = document.getElementById('question_box_text_' + this.props.question.number);

        if (box) {
          var questionBoxHeight = box.offsetHeight;

          if (boxText) {
            var textHeight = boxText.offsetHeight;

            if (!hasImg) {
              var halfBox = questionBoxHeight / 2;
              var halfText = textHeight / 2;
              var newMargin = halfBox - halfText;
              this.setState({
                marginTop: newMargin
              });
            } else {
              var halfSpace = (questionBoxHeight - maxImgHeight) / 2;

              var _halfText = textHeight / 2;

              var _newMargin = halfSpace - _halfText;

              this.setState({
                marginTop: Math.max(_newMargin, 5)
              });
            }
          }
        }
      } catch (error) {
        console.error('error while checking question font size', error);
      }
    }
  }, {
    key: "calculateFontSize",
    value: function calculateFontSize() {
      var _this5 = this;

      var imgHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var hasImage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var prevInnerHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var prevInnerWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      /*
      if (target.allowDifferentQuestionBoxSizes) {
        this.props.onPerfectFontSizeFound(MAX_FONT_SIZE)
        return
      }
        */
      if (!this.props.mustFitToDomWithId) {
        console.warn('no outer box given, so can\'t calculate appropriate font size');
        this.props.onPerfectFontSizeFound();
        return;
      }

      var textBox = document.getElementById("question_box_text_".concat(this.props.question.number));
      var outerBox = document.getElementById(this.props.mustFitToDomWithId);
      var innerTables = null;
      var widestInnerTable = null;

      if (textBox) {
        innerTables = textBox.getElementsByTagName('table');
        widestInnerTable = innerTables && innerTables.length > 0 ? (0, _from["default"])(innerTables).sort(function (t1, t2) {
          return t1.offsetWidth > t2.offsetWidth ? -1 : 1;
        })[0] : null;
      }

      if (textBox && outerBox) {
        var outerHeight = outerBox.offsetHeight;
        var outerWidth = outerBox.offsetWidth;
        var innerHeight = textBox.offsetHeight;
        var innerWidth = textBox.offsetWidth;
        var innerTableWidth = widestInnerTable ? widestInnerTable.offsetWidth : 0;

        if (innerWidth === prevInnerWidth && innerHeight === prevInnerHeight) {
          // it seems the last update is not rendered yet
          setTimeout(function () {
            _this5.calculateFontSize(imgHeight, hasImage, 0, 0); // set 0 to wait just once

          }, 40);
          return;
        }

        if (outerHeight - imgHeight < innerHeight || outerWidth < innerWidth || innerWidth < innerTableWidth) {
          // make font smaller
          var newSize = this.state.temporaryFontSize - (hasImage ? 1 : 0.5);
          this.setState({
            temporaryFontSize: newSize
          }, function () {
            if (newSize > MIN_FONT_SIZE) {
              _this5.calculateFontSize(imgHeight, hasImage, innerHeight, innerWidth); // const style = document.createElement('style')
              // document.head.appendChild(style)
              // const rule = `.${ownStyles.questionText} p, ul, ol, li {font-size: ${newSize}px; line-height: ${newSize + 1}px;}`
              // style.sheet.insertRule(rule)


              _this5.forceUpdate();
            } else {
              _this5.checkFontSize(imgHeight, hasImage);

              _this5.props.onPerfectFontSizeFound(newSize); // const style = document.createElement('style')
              // document.head.appendChild(style)
              // const rule = `.${ownStyles.questionText} p, ${ownStyles.questionText} ul, ${ownStyles.questionText} ol, ${ownStyles.questionText} li {font-size: ${newSize}px; line-height: ${newSize + 1}px;}`
              // style.sheet.insertRule(rule)
              // this.forceUpdate()

            }
          });
        } else {
          this.checkFontSize(imgHeight, hasImage);
          this.props.onPerfectFontSizeFound(this.state.temporaryFontSize); // const rule = `.${ownStyles.questionText} p, ${ownStyles.questionText} ul, ${ownStyles.questionText} ol, ${ownStyles.questionText} li {font-size: ${this.state.temporaryFontSize}px !important; line-height: ${this.state.temporaryFontSize + 1}px !important;}`
          // const style = document.createElement('style')
          // document.head.appendChild(style)
          // style.sheet.insertRule(rule)
          // this.forceUpdate()
        }
      }
    }
  }, {
    key: "getFontSize",
    value: function getFontSize() {
      return this.props.fontSize || this.state.temporaryFontSize;
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var fontSize = this.getFontSize();
      var questionStyle = {
        fontSize: "".concat(fontSize, "px"),
        lineHeight: "".concat(fontSize + 1, "px"),
        // no auto substitution from number to px by react for lineHeight
        margin: "".concat(Math.max(0, this.state.marginTop), "px 0 7px")
      };
      var normalQuestionContent = this.props.question.question;
      var mathMl = null;

      if (_DeviceInfoHelper["default"].isAndroid() && MathJax) {
        mathMl = _StringHelper["default"].getMathMlContent(this.props.question.question);

        if (mathMl && mathMl.length > 0) {
          normalQuestionContent = normalQuestionContent.replace(mathMl[0], '');
        }
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "question_box_".concat(this.props.question.number),
        style: {
          height: '100%'
        }
      }, _config["default"].showQDZoomButton && fontSize < 20 ? /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          return _this6.props.zoomText(_this6.props.question.question, true, _this6.props.frameId);
        },
        style: {
          position: 'absolute',
          right: '10px',
          top: '10px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        style: {
          fontSize: '20px',
          color: _cssConstants["default"].colors.zoomColor ? _cssConstants["default"].colors.zoomColor : 'white'
        },
        name: "search"
      })) : null, /*#__PURE__*/_react["default"].createElement("div", {
        id: "question_box_inner_".concat(this.props.question.number)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.props.scrollRef,
        id: "question_box_text_".concat(this.props.question.number),
        className: _Question["default"].questionText,
        style: questionStyle // dangerouslySetInnerHTML={{ __html: StringHelper.removeAllPAndReplaceWithBr(normalQuestionContent) }}
        ,
        dangerouslySetInnerHTML: {
          __html: normalQuestionContent
        }
      }), mathMl && mathMl[0] && /*#__PURE__*/_react["default"].createElement(MathJax, {
        math: mathMl[0]
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Question["default"].scrollIndicatorQuestionBox,
        style: !this.props.showScrollIndicator ? {
          display: 'none'
        } : {},
        onTouchStart: this.setIntervalHandleQuestionBox,
        onTouchEnd: function onTouchEnd() {
          return clearInterval(_this6.interval);
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        className: _Question["default"].arrowFirstQuestionBox,
        name: "angle-down"
      }), /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        className: _Question["default"].arrowSecondQuestionBox,
        name: "angle-down"
      }))));
    }
  }]);
  return QuestionBox;
}(_react["default"].Component); // noinspection Eslint


exports["default"] = QuestionBox;
QuestionBox.propTypes = {
  question: _propTypes["default"].object.isRequired,
  // eslint-disable-line
  showImgOverlay: _propTypes["default"].func,
  fontSize: _propTypes["default"].number,
  onPerfectFontSizeFound: _propTypes["default"].func.isRequired,
  mustFitToDomWithId: _propTypes["default"].string,
  zoomText: _propTypes["default"].func,
  frameId: _propTypes["default"].string,
  showImageOverlay: _propTypes["default"].func,
  editorMode: _propTypes["default"].bool,
  onTouchQuestions: _propTypes["default"].func,
  showScrollIndicator: _propTypes["default"].bool
};
QuestionBox.defaultProps = {
  smallDevice: false,
  fontSize: null,
  mustFitToDomWithId: null,
  showImageOverlay: function showImageOverlay() {}
};